jQuery(document).ready(function($) {

    /* ---------- Cookie Get Connected ---------- */
    if ($.cookie('the_cookie_connected_accueil') == 'true' || $.cookie('the_cookie_connected_all') == 'true') {
        $('.connected-container').css({
            'right': '-380px'
        });
    } else {
        $('.connected-container').css({
            'display': 'none'
        });
    }

    if ($.cookie('the_cookie_connected_bottom') == 'true' || $.cookie('the_cookie_connected_all') == 'true') {
        $(".connected-container.bottom").animate({
            height: 45
        }, 0, function() {
            $("#back-to-top").animate({
                bottom: 60
            }, 0);
        });
        $(".connected-container.bottom .col-md-4 p, .connected-container.bottom .col-md-3, .connected-container.bottom .col-md-2").animate({
            opacity: 0
        }, 0);
        $(".connected-spacer").animate({
            height: 25
        }, 0);
        $(".connected-container.bottom .fermer").css({
            'background': 'transparent url(/wp-content/themes/griffin/img/open.png) top left no-repeat'
        });

        var $connectedbottom = 'false';
    } else {
        var $connectedbottom = 'true';
    }

    // GET CONNECTED BUTTON
    $(".connected-button,.connected-container .fermer").click(function() {

        var connectContainer = $(this).parent().parent();
        var connectRight = connectContainer.css("right").replace(/[^-\d\.]/g, '');

        close_or_openit(connectRight);

    });

    var envoyer = 'false';
    $(document).on("click", ".connected-container.bottom .submitbutton", function() {
        $("#back-to-top").animate({
            bottom: 170
        }, 500, function() {
            $(".connected-container.bottom").animate({
                height: 150
            }, 500);
        });
        envoyer = 'true';
    });

    $(".connected-container.bottom .fermer").click(function() {
        if ($connectedbottom == 'true') {
            $.cookie('the_cookie_connected_bottom', 'true', {expires: 1, path: '/'});
            $(".connected-container.bottom").animate({
                height: 45
            }, 500, function() {
                $("#back-to-top").animate({
                    bottom: 60
                }, 500);
            });
            $(".connected-container.bottom .col-md-4 p, .connected-container.bottom .col-md-3, .connected-container.bottom .col-md-2").animate({
                opacity: 0
            }, 500);
            $(".connected-spacer").animate({
                height: 25
            }, 50);
            $(".connected-container.bottom .fermer").css({
                'background': 'transparent url(/wp-content/themes/griffin/img/open.png) top left no-repeat'
            });

            $connectedbottom = 'false';
        } else {
            $.cookie('the_cookie_connected_bottom', 'false', {expires: 1, path: '/'});
            if (envoyer == 'false') {
                $("#back-to-top").animate({
                    bottom: 120
                }, 500, function() {
                    $(".connected-container.bottom").animate({
                        height: 100
                    }, 500);
                });
            } else {
                $("#back-to-top").animate({
                    bottom: 170
                }, 500, function() {
                    $(".connected-container.bottom").animate({
                        height: 150
                    }, 500);
                });
            }
            $(".connected-container.bottom .col-md-4 p, .connected-container.bottom .col-md-3, .connected-container.bottom .col-md-2").animate({
                opacity: 1
            }, 500);
            $(".connected-spacer").animate({
                height: 100
            }, 50);
            $(".connected-container.bottom .fermer").css({
                'background': 'transparent url(/wp-content/themes/griffin/img/close.png) top left no-repeat'
            });

            $connectedbottom = 'true';
        }
    });

    function close_or_openit(connectRight) {
        $("#connect-fname").focus();

        if (connectRight < 0) {
            $.cookie('the_cookie_connected_accueil', 'false', {expires: 1, path: '/'});
            //open
            $(".connected-container").animate({
                right: "0"
            }, 500, function() { });
        } else {
            $.cookie('the_cookie_connected_accueil', 'true', {expires: 1, path: '/'});
            //close
            $(".connected-container").animate({
                right: "-380"
            }, 500, function() { });
        }
    }

    function cookieaccueil() {
        $.cookie('the_cookie_connected_all', 'true', {expires: 365, path: '/'});
    }

    /* ------------------------------------------------------------------------ */
    /* GALLERY */
    /* ------------------------------------------------------------------------ */
    if (typeof fancybox != 'undefined') {
        jQuery(".fancy").fancybox();
    }

    /* ------------------------------------------------------------------------ */
    /* image gallery */
    /* ------------------------------------------------------------------------ */
    $('#main-image-container').click(function() {
        $('#ngg-image-0 a').trigger("click");
    })

    /* ------------------------------------------------------------------------ */
    /* SHOW MORE */
    /* ------------------------------------------------------------------------ */

    $(".clickmore").click(function() {
        $(this).prev(".show-toggle").slideToggle(700);
    });


    /* ------------------------------------------------------------------------ */
    /* CONDOS SEARCH */
    /* ------------------------------------------------------------------------ */

    function startSearch(option) {

        // get all checked box
        var allCaracs = $('.dropdown-caracs :checked').serialize();
        var allPhases = $('.dropdown-phases :checked').serialize();
        var allCategories = $('[name="categories[]"]:checked').serialize();
        var occupationValue = $('#occupation').next().hasClass('selected');

        //get other values
        var minPrice = $("#slider-range").slider("values", 0);
        var maxPrice = $("#slider-range").slider("values", 1);
        var minSuperficie = $("#superficie-range").slider("values", 0);
        var maxSuperficie = $("#superficie-range").slider("values", 1);
        var model = $("#model").val();
        var rooms = $("#rooms").val();

        if(option == "less") {
            //reset more options values
            var optionsSR = $("#superficie-range").slider("option");
            minSuperficie = optionsSR.min;
            maxSuperficie = optionsSR.max;

            model = "all";
            allCaracs = "";
            allPhases = "";
        }

        if (occupationValue) {
            var occupation = 'occupation=1';
        } else {
            var occupation = '';
        }

        var params = {
            minPrice: minPrice,
            maxPrice: maxPrice,
            minSuperficie: minSuperficie,
            maxSuperficie: maxSuperficie,
            model: model,
            rooms: rooms
        };

        var getURL = $(".js-search").data("geturl");

        //send to the page
        window.location = getURL + "?" + $.param(params) + "&" + allCaracs + "&" + allPhases + "&" + allCategories + "&" + occupation;
    }

    $(".js-search").click(function() {
        startSearch("more");
    });

    $('a[data-type]').click(function() {
        $(this).toggleClass('selected');
        var type = $(this).data('type');
        $('[name="categories[]"][data-type="' + type + '"]').click();

        //if less options - category button will submit form
        if(!$(".more-options.is-visible").length) {
            startSearch("less");
        }
    });

    $(".js-toggle-options").click(function() {
        var myButton = $(this);
        var lessText = $(this).data("less");
        var moreText = $(this).data("more");
        var $choiceContainer = $(".more-options");
        $choiceContainer.toggleClass('is-visible');
        if ($choiceContainer.hasClass('is-visible')) {
            myButton.html(lessText);
        } else {
            myButton.html(moreText);
        }
    });

    $(document).mouseup(function(e)
    {
        var $containers = $(".dropdown-content");

        if ($(e.target).hasClass("choice-toggler") || $(e.target).parent().hasClass("choice-toggler")) {
            if ($(e.target).hasClass("choice-toggler")) {

                var $toggler = $(e.target);
                var $content = $toggler.siblings(".dropdown-content");

            } else if ($(e.target).parent().hasClass("choice-toggler")) {

                var $toggler = $(e.target).parent();
                var $content = $toggler.siblings(".dropdown-content");
            }
            if ($content.is(":visible")) {
                $content.fadeOut();
                $toggler.removeClass("open");
            } else {
                $content.fadeIn();
                $toggler.addClass("open");
            }

            return false;
        }

        $containers.each(function(index) {
            if (!$(this).is(e.target) // if the target of the click isn't the container...
                    && $(this).has(e.target).length === 0) // ... nor a descendant of the container
            {
                $(this).hide();
                $(this).children(".choice-toggler").removeClass("open");
            }
        });
    });

    //update label name
    $('.dropdown-content input[type="checkbox"]').change(function() {
        update_the_label();
    }).change();


    //allow to click on label instead of checkbox directly
    $("span.label_choice").click(function() {
        var checkboxTarget = $(this).data("choice");
        var theCheckbox = $("." + checkboxTarget);

        if (theCheckbox.is(":checked")) {
            theCheckbox.attr('checked', false);
        } else {
            theCheckbox.attr('checked', true);
        }

        update_the_label();

    });

    //update # of characteristics selected
    function update_the_label() {
        $('.dropdown-holder').each(function(index) {
            var $mySpan = $(this).find(".choice-toggler span.selected");
            var myLabel = $mySpan.data("label");
            var myChecked = $(this).find('.dropdown-content input[type="checkbox"]:checked').length;

            $mySpan.html(myChecked + " " + myLabel);
        })
    }


    /* ------------------------------------------------------------------------ */
    /* FILTER BY */
    /* ------------------------------------------------------------------------ */

    var $selects = $('#filterby');

    $selects.easyDropDown({
        cutOff: 10,
        onChange: function(selected) {

            var getURL = $(this).data("fullurl");

            window.location = getURL + "&orderby=" + selected.value;

        }
    });


    var $selects = $('#model');

    $selects.easyDropDown({
        cutOff: 10,
        onChange: function(selected) {

            var getURL = $(this).val();
            //window.location = getURL;
        }
    });

    var $selects = $('.blackSelect');
    $selects.easyDropDown();

    /* ------------------------------------------------------------------------ */
    /* CONTACT PAGE */
    /* ------------------------------------------------------------------------ */

    $(".js-toogle-office").click(function() {

        var menuIndex = $(this).index() + 1; //Li clicked index
        var content = $("#showContainer .office-content:nth-child(" + menuIndex + ")"); //content index

        //remove all active class
        remove_all_active();

        $(this).addClass("is-active");
        $(content).addClass("active");
    });

    $(".page-template-page-template-inscription-php .btn-inscription, .page-template-page-template-inscription-php .cta-reservation").click(function() {
        $('html, body').animate({
            scrollTop: $("#partner_banner").offset().top
        }, 1250, 'easeOutQuad');
    });

    function remove_all_active() {
        $(".js-toogle-office").removeClass("is-active");
        $(".office-content").removeClass("active");
    }

    /* ------------------------------------------------------------------------ */
    /* SEE THE CONDOS */
    /* ------------------------------------------------------------------------ */

    $("#priceButton").click(function() {

        var val1 = $("#slider-range").slider("values", 0);
        var val2 = $("#slider-range").slider("values", 1);
        var rooms = $("#rooms").val();
        var polesID = $("#polesID").val();

        var params = {minPrice: val1, maxPrice: val2, rooms: rooms, phases: polesID};

        var getURL = $(this).data("geturl");

        //send to the page
        window.location = getURL + "?" + $.param(params);

    });

    /* ------------------------------------------------------------------------ */
    /* HOME NEWS SLIDER */
    /* ------------------------------------------------------------------------ */


    $('#home-news-slider').flexslider({'controlNav': false});

    /* ------------------------------------------------------------------------ */
    /* MODEL SLIDER */
    /* ------------------------------------------------------------------------ */

    $('.modelslider').flexslider({animation: "slide", 'controlNav': true});


    /* ------------------------------------------------------------------------ */
    /* Default */
    /* ------------------------------------------------------------------------ */

    $('.widget-tab-nav a').click(function(e) {
        e.preventDefault();
        $(this).tab('show');
    });


    /* ------------------------------------------------------------------------ */
    /* DISTRICT SLIDER
     /* ------------------------------------------------------------------------ */

    $("#arrows .right").on("click", function() {

        $(".tp-rightarrow").trigger("click");

    });


    $("#arrows .left").on("click", function() {

        $(".tp-leftarrow").trigger("click");

    });



    /* ------------------------------------------------------------------------ */
    /* FORMULAIRE */
    /* ------------------------------------------------------------------------ */
    $("#connect-submit-mobile, #connect-submit:not([disabled]), #popup-submit:not([disabled]), #inscription-submit").click(function(event) {

        var $this = $(this);
        var $thisID = $(this).prop("id");

        event.preventDefault();

        if ($this.hasClass('is-active')) {
            return false;
        }

        $this.hide(); //activate clicks

        var type = $this.data('type'),
                thisParentID = $this.data("parent"),
                trackingAdGear = $this.hasClass('tracking_adgear');

        var theForm = event.target,
                theFormParent = $(theForm).parent(),
                theButtonForm = $(theForm).attr("data-parent");

        $(thisParentID + " .connect-error").html($(thisParentID + " .connect-error").data("default")).fadeOut();
        $(thisParentID + " .connect-success").fadeOut();

        var hasError = false;

        $(thisParentID + ' .requiredField').each(function() {
            var $input = $(this);
            if ($.trim($input.val()) === '' || $input.val() === $input.attr('placeholder')) {
                $input.addClass('inputError');
                hasError = true;
            } else if ($input.hasClass('email')) {
                var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
                if (!emailReg.test($.trim($input.val()))) {
                    $input.addClass('inputError');
                    hasError = true;
                } else {
                    $input.removeClass('inputError');
                }
            } else {
                $input.removeClass('inputError');
            }
        });

        if (!hasError) {
            var form;
            if (type === 'promotion' || type === 'footer' || type === 'inscription') {
                form = $this.parents('form');
                data = form.serializeArray();
                data.push({name: 'action', value: 'connect_to_crm'});
            } else {
                form = $this.parents('form');

                data = {
                    action: 'connect_to_crm',
                    email: $(thisParentID + " #connect-email").val(),
                    phone: $(thisParentID + " #connect-phone").val(),
                    lname: $(thisParentID + " #connect-lname").val(),
                    fname: $(thisParentID + " #connect-fname").val(),
                    onpage: $(thisParentID + " #connect-onpage").val(),
                    newsletter: newsletter,
                    gender: $(thisParentID + " #connect-gender").val()
                };
            }

            var newsletter = $(thisParentID + " #connect-newsletter").is(':checked') ? 1 : 0;


            $this.attr('disabled', 'disabled').addClass("is-active");


            $(form).find('.loading-gif').show();

            jQuery.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                data: data,
                dataType: 'JSON',
                success: function(data, textStatus, XMLHttpRequest) {

                    //on success
                    if (data.success) {
                        if (trackingAdGear) {
                            buttonAdGearTracking();
                        }

                        /*#connect-submit-mobile,
                         #connect-submit,//
                         #popup-submit,//
                         #inscription-submit */

                        // This is the push for the footer newsletter subscription
                        if (theButtonForm == "#form-infolettre") {
                            _gaq.push(['_trackEvent', 'form', 'subscription', 'newsletter footer']);
                        }

                        // This is the push for the popup newsletter subscrption
                        else if (theButtonForm == ".popup__subscribe") {
                            _gaq.push(['_trackEvent', 'form', 'subscription', 'newsletter popup']);
                        }

                        // This is the push for the contact page newsletter subscrption
                        else if (theButtonForm == "#connected-container-contact") {
                            _gaq.push(['_trackEvent', 'form', 'subscription', 'newsletter contact']);
                        }

                        // This is the push for the single condo get information
                        else if (theButtonForm == ".popup__request_information") {
                            _gaq.push(['_trackEvent', 'request', 'send', 'request info condo']);
                        }

                        if (window.__ADGEAR) {
                            window.__AGDATA.ConvType = "lead";
                            __ADGEAR.load_usegment("cXhxpq3GSuZPc3UEBu4bhXxkZnNEW2j96xyWG6lN7Qk=","106");
                        }

                        $(form).find('input').each(function() {
                            $(this).val('').prop("checked", false);
                        });
                        //reset inputs
                        $(thisParentID + " .connected-container input, ".thisParentID + " .connected-container-mobile input").each(function() {
                            $(this).val('');
                        });


                        if (type === 'promotion') {
                            $(form).fadeOut();
                        }

                    } else {
                        $(thisParentID + " .connect-error").html(data.error).fadeIn();
                    }


                    if ( !theButtonForm == ".popup__subscribe") {
                        $(form).parents('.bg__grey').removeClass("bg__grey");
                    }
                    $this.removeAttr('disabled').removeClass("is-active");

                    if (theButtonForm == "#connected-container-contact") {
                        form = $("#connected-container-contact");

                        $(form).find('input, [data-parent], .black, .white').remove();
                        $(form).parent().find(".connect-success").fadeIn().css("display", "block");
                    }

                    else if ( theButtonForm == ".popup__subscribe") {
                        $(form).parents("#subscribe-popup").find(".connect-success").fadeIn().css("display", "block");
                    }

                    else {
                        $(form).parent().find(".connect-success").fadeIn().css("display", "block");
                        $(form).remove();
                    }

                    $(form).find('.loading-gif').hide();
                    $('.hide-on-success').hide();
                    $('.show-on-success').show();

                },
                error: function(MLHttpRequest, textStatus, errorThrown) {}
            });

        } else {

            $(thisParentID + " .connect-error").fadeIn();

        }
        $(this).show(); //activate clicks
    });

    $('.district-form').on('submit', function(e) {
        if (!$(".district-form").parsley().isValid()) {
            return false;
        }
        e.preventDefault();
        if ($(this).hasClass('tracking_adgear')) {
            buttonAdGearTracking();
        }
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: $(this).serializeArray(),
            dataType: 'JSON',
            type: 'POST',
            success: function(data) {
                if (data.success) {
                    $('.district-form-confirm').show();
                    $('.district-form-warning').hide();
                    $('.district-form').hide();

                    if (window.__ADGEAR) {
                        window.__AGDATA.ConvType = "lead";
                        __ADGEAR.load_usegment("cXhxpq3GSuZPc3UEBu4bhXxkZnNEW2j96xyWG6lN7Qk=","106");
                    }

                } else {
                    $('.district-form-warning').show().find('p').html(data.error);
                    $('.district-form-confirm').hide();
                }
            },
            error: function(MLHttpRequest, textStatus, errorThrown) {
                var error = $('.district-form-warning').data('error');
                $('.district-form-warning').show().find(p).html(error);
                $('.district-form-confirm').hide();
            }
        });
        return false;
    });

    $('.form-subscription').on('submit', function(){
        var $form = $(this);

        if ($form.parsley().isValid()) {
            $form.find(':input[type="submit"]').attr('disabled', true);
        }
    });

    /* ------------------------------------------------------------------------ */
    /* GET CONNECTED MOBILE */
    /* ------------------------------------------------------------------------ */
    var getconnectedmobile = 'false';
    $(document).on("click", ".connected-container-mobile h3", function() {
        if (getconnectedmobile == 'false') {
            $(this).css({
                '-webkit-transition': 'all 0.3s linear',
                '-moz-transition': 'all 0.3s linear',
                '-ms-transition': 'all 0.3s linear',
                '-o-transition': 'all 0.3s linear',
                'transition': 'all 0.3s linear',
                'background-color': '#000',
                'color': '#0e84dc'
            });
            $('.connected-container-mobile .row').css({
                'display': 'inline'
            });
            getconnectedmobile = 'true';
        } else {
            $(this).css({
                '-webkit-transition': 'all 0.3s linear',
                '-moz-transition': 'all 0.3s linear',
                '-ms-transition': 'all 0.3s linear',
                '-o-transition': 'all 0.3s linear',
                'transition': 'all 0.3s linear',
                'background-color': '#0e84dc',
                'color': 'white'
            });
            $('.connected-container-mobile .row').css({
                'display': 'none'
            });
            getconnectedmobile = 'false';
        }
    });



    /* ------------------------------------------------------------------------ */
    /* FORMULAIRE EVENT */
    /* ------------------------------------------------------------------------ */
    $("#event_form span.submit").click(function(event) {

        event.preventDefault();

        $("#event_form .connect-error").hide();

        var myBtn = $("#event_form span.submit");

        myBtn.hide(); //deactivate clicks

        var hasError = false;

        $('#event_form .requiredField:visible').each(function() {
            if ($.trim($(this).val()) == '' || $(this).val() == $(this).attr('placeholder')) {
                $(this).addClass('inputError');
                hasError = true;
            } else if ($(this).hasClass('email')) {
                var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
                if (!emailReg.test($.trim($(this).val()))) {
                    $(this).addClass('inputError');
                    hasError = true;
                } else {
                    $(this).removeClass('inputError');
                }
            } else {
                $(this).removeClass('inputError');
            }
        });

        if (!hasError) {

            jQuery.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                data: $("#event_form").serialize(),
                success: function(data, textStatus, XMLHttpRequest) {

                    //on success
                    if (data == "1") {

                        $("#step1_form").hide();

                        $("#event_thankyou").fadeIn();

                    } else {
                        $("#event_form .connect-error").html(data).fadeIn();
                    }

                    myBtn.show();

                },
                error: function(MLHttpRequest, textStatus, errorThrown) {
                    myBtn.show();
                }
            });

        } else {

            $("#event_form .connect-error").fadeIn();

            myBtn.show(); //activate clicks

            $(".selectHold .dropdown").each(function(index) {
                if ($(this).find(".select").hasClass("inputError")) {
                    $(this).find('.selected').addClass('inputError');
                } else {
                    $(this).find('.selected').removeClass('inputError');
                }
            });

        }



    });



    /* ------------------------------------------------------------------------ */
    /* Parallax */
    /* ------------------------------------------------------------------------ */

    // call the plugin
    $('.parallax').parallax("50%", 0.5, false);

    $('.slow-parallax').parallax("50%", 0.2, false);


    /* ------------------------------------------------------------------------ */
    /* Back To Top */
    /* ------------------------------------------------------------------------ */

    $(window).scroll(function() {
        if ($(window).scrollTop() > 200) {
            $("#back-to-top").fadeIn(200);
        } else {
            $("#back-to-top").fadeOut(200);
        }
    });

    $('#back-to-top, .back-to-top').click(function() {
        $('html, body').animate({scrollTop: 0}, '200');
        return false;
    });


    /*
     //////////////////////////////////////////////////////////////////////////////////////////////

     Mobile menu

     //////////////////////////////////////////////////////////////////////////////////////////////
     */

    $('.mobileMenu_tool .opener').click(function() {
        $("#mobileMenu > ul").slideToggle(500);
        $(this).toggleClass("active");
        return false;
    });

    $('#mobileMenu li').has("ul").addClass("droppy");

    // Mobile Menu
    $('#mobileMenu ul li ul').parent("li").addClass("dropper").append("<span></span>");
    $('#mobileMenu li.dropper > a,#mobileMenu li.dropper span').click(function() {
        $(this).parent("li").find("ul:first").slideToggle(400);
        $(this).parent("li").toggleClass("active");
        return false;
    });

    $('.js-scroll-to[href^="#"]').click(function() {
        var the_id = $(this).attr("href");
        if ($(the_id).length) {
            $('html, body').animate({
                scrollTop: $(the_id).offset().top
            }, 600);
        }
        return false;
    });

});

function buttonAdGearTracking() {
    var agData = document.createElement("script");
    agData.innerHTML =
            '__AGDATA = {' +
            'AdName: "districtgriffin.com",' +
            'ConvType: "lead",' +
            'CustomerID: 0,' +
            'PageType: "",' +
            'Language: "",' +
            'Data: "",' +
            'Revenue: 0' +
            '};'
    document.getElementsByTagName("body")[0].appendChild(agData);

    var __AG_UNIVERSAL_SCRIPT_TAG = document.createElement("script");
    __AG_UNIVERSAL_SCRIPT_TAG.setAttribute("type", "text/javascript");
    __AG_UNIVERSAL_SCRIPT_TAG.setAttribute("src", "//cdn.adgrx.com/usegments/cXhxpq3GSuZPc3UEBu4bhXxkZnNEW2j96xyWG6lN7Qk=/106.js");
    __AG_UNIVERSAL_SCRIPT_TAG.setAttribute("async", "true");
    document.getElementsByTagName("body")[0].appendChild(__AG_UNIVERSAL_SCRIPT_TAG);
}


//GO TO LINK
function goTo(hash) {
    jQuery.scrollTo(hash, 1500); //{ easing:'elasout' }
    return false;
}

// Add spaces in large numbers
function addSpaces(nStr) {
    return nStr.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ");
}

//Open the popup connect
function triggerConnect() {
    jQuery(".connected-button").trigger("click");
}

/*
 //////////////////////////////////////////////////////////////////////////////////////////////

 Scroll animation

 //////////////////////////////////////////////////////////////////////////////////////////////
 */

function scrollToAnchor(aid) {
    var aTag = $("." + aid);
    $('html,body').animate({scrollTop: aTag.offset().top}, 'slow');
}
